import React from 'react';
import { Link } from 'react-router-dom';
import { getImageUrl } from '../../../utils/imageUtils';

const PostsSection = ({ posts }) => (
    <div className="rounded-2xl bg-white border border-secondary-200 shadow-soft p-5">
        <div className="flex items-center gap-2 mb-4">
            <span className="text-sm font-semibold text-secondary-900">Посты пользователя</span>
        </div>
        <div className="grid grid-cols-1 gap-4">
            {posts.map((post) => (
                <div
                    key={post.id}
                    className="table w-full bg-white/80 dark:bg-secondary-900/80 rounded-xl shadow-soft p-6"
                >
                    {post.image_url && (
                        <img
                            src={getImageUrl(post.image_url)}
                            alt={`Пост: ${post.title || post.body}`}
                            className="post-img object-cover rounded-lg"
                            loading="lazy"
                        />
                    )}
                    <div className="text-xs text-secondary-700">
                        {post.published_at && new Date(post.published_at).toLocaleString('ru-RU', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric'
                        })}
                    </div>
                    <div className="font-bold text-base text-secondary-900">{post.title || post.body}</div>
                    <div className="text-sm text-secondary-700 whitespace-pre-wrap break-words">{post.title ? post.body : ''}</div>
                    {post.link_url && (
                        <a
                            href={post.link_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-primary-700 hover:underline text-xs"
                        >
                            {post.link_url}
                        </a>
                    )}

                    {post.slug && (
                        <Link to={`/posts/${post.slug}`} className="text-xs text-primary-700 hover:underline">
                            Открыть
                        </Link>
                    )}
                </div>
            ))}
        </div>
    </div>
);

export default PostsSection;
